import React from "react";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import { CentreData } from "types/models/support/SupportApp";
import AppTableContainer from "@crema/core/AppTableContainer";
import TableHeading from "./TableHeading";
import TableItem from "./TableItem";
interface CentreTableProps {
  centre: CentreData[];
}

const CentreTable: React.FC<CentreTableProps> = ({ centre }) => {
  return (
    <AppTableContainer>
      <Table stickyHeader className="table">
        <TableHead>
          <TableHeading />
        </TableHead>
        <TableBody>
          {centre.map((data) => (
            <TableItem data={data} key={data.sNo} />
          ))}
        </TableBody>
      </Table>
    </AppTableContainer>
  );
};

export default CentreTable;
